import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/app/support/SupportContent.tsx");
